import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import {
  StatusBarWrapper,
  BoxWrapper,
} from './css';


const FmSaleSupportStatusBar = ({
  step,
  isLastStep,
  onProceedClick,
  onBackClick
}) => {
  const localizedStrings = useLocalizedStringsContext();

  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      submitButtonLabel
    }
  } = localizedStrings;



  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
            <>
              {step !== 1 && (
                <button
                  type="button"
                  onClick={onBackClick}
                  className="frg-button color-green"
                >
                  {backLabel}
                </button>
              )}

              <button
                type="button"
                onClick={e => onProceedClick(e)}
                style={{ marginLeft: '1em', height: '60px', marginTop: '1px' }}
                className={`frg-button color-${
                  isLastStep ? 'purple' : 'green'
                }`}
              >
                {isLastStep ? "Cancel" : continueButtonLabel}
              </button>
            </>

        </BoxWrapper>
      </div>

    </StatusBarWrapper>
  );
};

FmSaleSupportStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
};

FmSaleSupportStatusBar.defaultProps = {};

export default FmSaleSupportStatusBar;
